<template>
  <div style="cursor: pointer">
    <template>
      <Poptip placement="bottom" width="300" ref="poptipModal">
        <span> {{ text }} </span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              修改价格：
              <InputNumber
                v-model="Price"
                style="width: 150px"
              />
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onModalSubmit"
                >确定</Button
              >
            </div>
          </div>
        </template>
      </Poptip>
    </template>
  </div>
</template>

<script>
export default {
  props: ["text", "item"],
  data() {
    return {
      Price: "",
    };
  },
  created() {
    this.Price = this.text;
  },
  methods: {
    async onModalSubmit() {
      this.item.endTotalPrice = this.Price;
      let q = this.item;
      let res = await $utils.api.load(
        "/admin/system/procurementWork/editMoney",
        q,
        "post"
      );
      if (res.code == 200) {
        this.$refs.poptipModal.handleClose();
        $utils.toast.success("修改成功！");
        this.$emit("reset");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  padding: 20px;

  .unitPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .modal_content_btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
